import InputBase, { InputBaseProps } from '@mui/material/InputBase'
import InputAdornment from '@mui/material/InputAdornment'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

interface Props extends InputBaseProps {
  label?: string
  isError?: boolean
  errorText?: string
  leftIcon?: React.ReactNode
  rightIcon?: React.ReactNode
  onToggleIcon?: () => void
}

export function Input({
  label,
  isError,
  errorText,
  leftIcon,
  rightIcon,
  onToggleIcon,
  ...props
}: Props) {
  return (
    <Box sx={{ width: '100%' }}>
      {label && (
        <Typography variant='label' sx={{ mb: 1, display: 'block', fontWeight: 500 }}>
          {label}
        </Typography>
      )}
      <InputBase
        fullWidth
        startAdornment={
          leftIcon ? <InputAdornment position='start'>{leftIcon}</InputAdornment> : null
        }
        endAdornment={
          rightIcon ? (
            <InputAdornment position='end'>
              <IconButton onClick={onToggleIcon} edge='end'>
                {rightIcon}
              </IconButton>
            </InputAdornment>
          ) : null
        }
        error={isError}
        sx={{
          backgroundColor: '#f5f5f5',
          border: '2px solid',
          borderColor: isError ? '#ef4444' : '#e0e0e0',
          borderRadius: '8px',
          padding: '12px 16px',
          fontSize: '15px',
          transition: 'all 0.2s ease',
          '&:hover': {
            backgroundColor: '#f0f0f0',
            borderColor: isError ? '#ef4444' : '#d1d5db',
          },
          '&.Mui-focused': {
            backgroundColor: '#ffffff',
            borderColor: isError ? '#ef4444' : '#1a1a1a',
            boxShadow: isError
              ? '0 0 0 3px rgba(239, 68, 68, 0.1)'
              : '0 0 0 3px rgba(26, 26, 26, 0.1)',
          },
          '& .MuiInputBase-input': {
            padding: 0,
            '&::placeholder': {
              color: '#9ca3af',
              opacity: 1,
            },
          },
        }}
        {...props}
      />
      {errorText && isError && (
        <Box mt={0.75}>
          <Typography variant='body2' color='error.main' fontSize='13px'>
            {errorText}
          </Typography>
        </Box>
      )}
    </Box>
  )
}
